module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box-container"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('header', [_vm._t("header")], 2), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cf084d5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoBox.vue
// module id = 369
// module chunks = 1